import { render, staticRenderFns } from "./ApeironForms.vue?vue&type=template&id=6aaf8896"
import script from "./ApeironForms.vue?vue&type=script&lang=js"
export * from "./ApeironForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports